"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=articles.js.map